import MDCheckbox from "components/MDCheckbox";

export const ListingTableHeader = ({
  headerChecked,
  onHeaderChange,
  pagePermission,
}) => [
  {
    Header: (
      <MDCheckbox
        label="Type"
        checked={headerChecked}
        onChange={(e) => onHeaderChange(e.target.checked)}
      />
    ),
    accessor: "listing_type",
    align: "left",
    width: "7%",
  },
  { Header: "Listing#", accessor: "listing_id", align: "left", width: "8%" },
  { Header: "Title", accessor: "title", align: "left" },
  { Header: "Final Price", accessor: "price", align: "right", width: "7%" },
  { Header: "Category", accessor: "category", align: "left", width: "10%" },
  { Header: "Gender/Qty", accessor: "gender", align: "left", width: "10%" },
  { Header: "Reserve Status", accessor: "reserve_status", align: "left", width: "10%" },
  { Header: "Closing Date", accessor: "end_date", align: "left", width: "5%" },
  ...(pagePermission.status || pagePermission.edit || pagePermission.remove
    ? [
        {
          Header: "Actions",
          accessor: "action",
          width: "7%",
          align: "center",
        },
      ]
    : []),
];
